module.exports = __webpack_public_path__ + "static/media/staking-img.3e37184c.png";